import { getLinkPath } from '@lucid/gatsby-theme-lucid';
import { graphql } from 'gatsby';
import { Box } from 'lucid-components-react';
import React, { FC, useContext } from 'react';

import Link from 'components/link/link';
import LayoutContext from 'contexts/layoutContext';
import {
  Drupal_ParagraphLink,
  Drupal_ParagraphListOfLinks
} from 'generated/graphql';
import { Text } from 'theme/typography';

interface Props {
  entity: Drupal_ParagraphListOfLinks;
  columnSize?: number;
}

const ListOfLinks: FC<Props> = ({ entity, columnSize, ...rest }) => {
  const { fieldHeader, fieldLinkData } = entity;
  const {
    language: { langPrefix }
  } = useContext(LayoutContext);

  const columns = columnSize
    ? Math.floor(fieldLinkData?.length! / columnSize) + 1
    : 1;

  return (
    <Box {...rest}>
      <Text
        css={theme => ({
          fontWeight: theme.fontWeights.bold,
          margin: `0 0 ${theme.space[5]}px`
        })}
        textStyles="body"
      >
        {fieldHeader}
      </Text>
      <ul
        css={theme => ({
          columns,
          listStyle: 'none',
          margin: 0,
          [`@media screen and (max-width: ${theme.breakpoints.tabletLandscape})`]: {
            columns: 1
          }
        })}
      >
        {fieldLinkData
          ?.filter(linkData => linkData?.entity?.entityTranslation)
          .map(linkData => {
            const { entityId, fieldCta } = linkData?.entity
              ?.entityTranslation as Drupal_ParagraphLink;

            return (
              <li
                key={entityId}
                css={theme => ({ margin: `0 0 ${theme.space[3]}px` })}
              >
                <Link
                  css={theme => ({ fontSize: theme.fontSizes[4] })}
                  to={getLinkPath(fieldCta?.url, langPrefix)}
                >
                  {fieldCta?.title}
                </Link>
              </li>
            );
          })}
      </ul>
    </Box>
  );
};

export default ListOfLinks;

export const query = graphql`
  fragment listOfLinks on Drupal_ParagraphListOfLinks {
    fieldHeader
    fieldLinkData {
      entity {
        entityTranslation(language: $LanguageId) {
          ... on Drupal_ParagraphLink {
            entityId
            fieldCta {
              title
              url {
                ...getLinkPath
              }
            }
          }
        }
      }
    }
  }
`;
